import React from "react";

var LoadingIndicator = function LoadingIndicator(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("img", {
    className: className,
    src: "assets/images/environment/default/layout/bits/indicator-loading-normal.gif",
    alt: "Loading..."
  });
};

export default LoadingIndicator;